import t from "../../theme";

export const useGetSignupScreenStyles = ({ stepNo, error }) => {
  return {
    /* ─── Progress stepper ─── */
    stepperWrapper: {
      width: "100%",
      maxWidth: 600,
      margin: "24px auto 0",
      height: 6,
      borderRadius: 20,
      background: "rgba(46, 125, 50, 0.08)",
      position: "relative",
      overflow: "hidden",
    },
    stepperFill: {
      width: `${50 * stepNo}%`,
      height: "100%",
      borderRadius: 20,
      transition: "width 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
      background: error
        ? t.brand.red
        : "linear-gradient(90deg, #66bb6a, #43a047, #2e7d32)",
      boxShadow: error ? "none" : "0 0 10px rgba(46, 125, 50, 0.35)",
    },
    stepLabel: {
      textAlign: "center",
      fontSize: 13,
      fontWeight: 600,
      color: "#555",
      marginTop: 6,
      letterSpacing: "0.3px",
    },

    /* ─── Page wrapper ─── */
    pageWrapper: {
      minHeight: "100vh",
      paddingBottom: 48,
    },

    /* ─── Back button ─── */
    backButton: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "8px 16px",
      margin: "20px 0 0 40px",
      cursor: "pointer",
      color: "#2e7d32",
      fontSize: 14,
      fontWeight: 600,
      borderRadius: t.radius.md,
      background: "rgba(46, 125, 50, 0.06)",
      border: "1px solid rgba(46, 125, 50, 0.12)",
      transition: t.transition.fast,
      "&:hover": {
        background: "rgba(46, 125, 50, 0.12)",
        borderColor: "rgba(46, 125, 50, 0.2)",
      },
    },
    backIcon: {
      height: 16,
      opacity: 0.8,
    },

    /* ─── Form layout ─── */
    signUpFormContainer: {
      display: "flex",
      justifyContent: "center",
      maxWidth: "85%",
      margin: "0 auto",
      padding: "24px 0",
      position: "relative",
    },

    /* ─── Left illustration ─── */
    illustration: {
      position: "absolute",
      left: 0,
      bottom: 0,
      height: "90%",
      minHeight: 625,
      filter: "drop-shadow(0 8px 24px rgba(46, 125, 50, 0.1))",
      zIndex: 0,
    },

    /* ─── Glass card form ─── */
    signupForm: {
      width: 560,
      display: "flex",
      gap: 20,
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      zIndex: 1,
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,0.68) 100%)",
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      borderRadius: t.radius.lg,
      border: "1px solid rgba(46, 125, 50, 0.1)",
      boxShadow:
        "0 8px 32px rgba(46, 125, 50, 0.06), 0 1px 3px rgba(0,0,0,0.04)",
      padding: "32px 36px",
    },
    profileCompletionForm: {
      width: "100%",
      maxWidth: 980,
    },

    /* ─── Heading ─── */
    formHeading: {
      margin: 0,
      fontSize: 26,
      fontWeight: 700,
      color: "#1b5e20",
      letterSpacing: "-0.3px",
      textAlign: "center",
      width: "100%",
    },
    socialSection: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 10,
      marginTop: 4,
    },
    socialButton: {
      minHeight: 54,
      borderRadius: t.radius.md,
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(241,248,242,0.98) 100%)",
      color: "#1a4d1a",
      fontSize: "16px",
      fontWeight: 700,
      textTransform: "none",
      boxShadow: "0 14px 26px rgba(0,0,0,0.10)",
      "&:hover": {
        background:
          "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(246,252,247,1) 100%)",
      },
      "&.Mui-disabled": {
        color: "rgba(26,77,26,0.6)",
      },
    },
    socialButtonContent: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
    },
    socialHelper: {
      margin: 0,
      fontSize: 13,
      lineHeight: 1.6,
      color: "#5d6b60",
      textAlign: "center",
    },
    oauthError: {
      padding: "12px 14px",
      borderRadius: t.radius.md,
      background: "rgba(183, 28, 28, 0.08)",
      border: "1px solid rgba(183, 28, 28, 0.16)",
      color: "#b71c1c",
      fontSize: 13,
      lineHeight: 1.5,
    },

    /* ─── Field groups ─── */
    formFieldsWrapper: {
      width: "100%",
    },
    profileCompletionContent: {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "280px minmax(0, 1fr)",
      gap: 24,
      alignItems: "start",
      "@media (max-width: 767px)": {
        gridTemplateColumns: "1fr",
      },
    },
    profilePhotoPanel: {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      padding: "20px 18px",
      borderRadius: "20px",
      background:
        "linear-gradient(180deg, rgba(241,248,242,0.95) 0%, rgba(255,255,255,0.92) 100%)",
      border: "1px solid rgba(46, 125, 50, 0.12)",
      boxShadow: "0 12px 24px rgba(27, 94, 32, 0.08)",
    },
    profilePhotoHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
    },
    profilePhotoTitle: {
      margin: 0,
      fontSize: 18,
      fontWeight: 700,
      color: "#1b5e20",
    },
    profilePhotoOptional: {
      padding: "4px 10px",
      borderRadius: 999,
      fontSize: 12,
      fontWeight: 700,
      color: "#2e7d32",
      background: "rgba(46, 125, 50, 0.1)",
    },
    profilePhotoDescription: {
      margin: 0,
      fontSize: 13,
      lineHeight: 1.6,
      color: "#5d6b60",
    },
    profilePhotoPreviewFrame: {
      width: "100%",
      aspectRatio: "1 / 1",
      borderRadius: "24px",
      overflow: "hidden",
      border: "1px dashed rgba(46, 125, 50, 0.26)",
      background:
        "radial-gradient(circle at top, rgba(102, 187, 106, 0.18), rgba(255,255,255,0.98) 70%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    profilePhotoPreviewImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
    },
    profilePhotoEmptyState: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      color: "#2e7d32",
      textAlign: "center",
      padding: 24,
    },
    profilePhotoEmptyIcon: {
      width: 52,
      height: 52,
      borderRadius: "50%",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 28,
      fontWeight: 700,
      background: "rgba(46, 125, 50, 0.14)",
    },
    profilePhotoEmptyText: {
      fontSize: 14,
      fontWeight: 700,
    },
    profilePhotoInput: {
      display: "none",
    },
    profilePhotoButton: {
      minHeight: 46,
      borderRadius: t.radius.md,
      textTransform: "none",
      fontWeight: 700,
    },
    profilePhotoHint: {
      margin: 0,
      fontSize: 12,
      lineHeight: 1.5,
      color: "#6b7280",
    },
    profileFieldsColumn: {
      width: "100%",
      minWidth: 0,
    },
    formFieldsGroup: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 12,
    },

    /* --- Social signup (Google) --- */
    socialSignupBlock: {
      width: "100%",
      padding: "14px 14px 10px",
      borderRadius: t.radius.md,
      border: "1px dashed rgb(80 170 50)",
      background: "rgba(255, 255, 255, 0.65)",
      boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
      display: "flex",
      flexDirection: "column",
      gap: 10,
    },
    googleActionButton: {
      borderRadius: t.radius.md,
      background: "linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)",
      boxShadow: "0 10px 18px rgba(27, 94, 32, 0.16)",
      "&:hover": {
        background: "linear-gradient(135deg, #2b7430 0%, #18541d 100%)",
      },
    },
    socialButtonLabel: {
      flex: 1,
      textAlign: "left",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
    authErrorBox: {
      width: "100%",
      borderRadius: t.radius.md,
      padding: "10px 12px",
      fontSize: 12,
      fontWeight: 600,
      color: "#7f1d1d",
      background: "rgba(220, 38, 38, 0.08)",
      border: "1px solid rgba(220, 38, 38, 0.22)",
    },
    socialDividerRow: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 12,
      color: "#607d8b",
      fontSize: 12,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      "&::before": {
        content: '""',
        height: 1,
        flex: 1,
        background: "rgba(46, 125, 50, 0.16)",
      },
      "&::after": {
        content: '""',
        height: 1,
        flex: 1,
        background: "rgba(46, 125, 50, 0.16)",
      },
    },
    formFieldsGroupmobile: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 16,
    },

    /* ─── Section label (Gender, etc.) ─── */
    sectionLabel: {
      fontSize: 14,
      fontWeight: 600,
      color: "#333",
      margin: "4px 0 -4px",
    },

    /* ─── Footer buttons ─── */
    submitButton: {
      borderRadius: t.radius.md,
    },
    footerBtn: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 16,
      padding: "8px 0 0",
    },
    footerBtnmobile: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: 16,
      padding: "8px 0 0",
    },

    /* ─── Misc ─── */
    errorText: {
      fontSize: 14,
      color: t.brand.red,
      fontWeight: 500,
    },
    formFieldsFlexGroup: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
    },
    formFieldsFlexRowGroup: {
      height: "2.5rem",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
    },
    dobLabel: {
      fontSize: 13,
      fontWeight: 600,
      color: "#555",
      marginBottom: 4,
      display: "block",
    },
    relative: {
      position: "relative",
    },
    id_thumb: {
      width: "200px",
      height: "100%",
      borderRadius: t.radius.md,
      marginTop: 8,
      border: "1px solid rgba(46, 125, 50, 0.1)",
    },
  };
};
